<template>
  <el-aside
    class="aside-bar lyoutFromLeftSide"
    id="lyoutFromLeftSide"
    :style="{ width: !isCollapse ? 'auto' : 'auto' }"
  >
    <section class="aside-bar_nav">
      <el-menu
        class="el-menu-vertical-demo"
        unique-opened
        :default-active="activeIndex"
        :collapse="isCollapse"
        mode="vertical"
        @select="handleSelect"
      >
        <el-menu-item class="menuTtitle">
          <i v-show="!isCollapse" class="el-icon-menu"></i>
          <i
            v-show="isCollapse"
            class="el-icon-d-arrow-right"
            @click="handleClose"
          ></i>
          <span>{{ muneTitle }}</span>
          <i
            v-show="!isCollapse"
            class="el-icon-d-arrow-left"
            @click="handleClose"
          ></i>
        </el-menu-item>
        <template v-for="(item, index) in menuData">
          <template v-if="item.children && item.children.length > 0">
            <el-submenu :key="index" :index="item.path">
              <template slot="title">
                <template v-if="item.iconClass && item.iconClass.length > 0">
                  <i :class="item.iconClass"></i>
                  <span slot="title">{{ item.menuName }}</span>
                </template>
                <template v-else>
                  <span slot="title">{{ item.menuName }}</span>
                </template>
              </template>
              <el-menu-item
                v-for="(item2, index2) in item.children"
                :key="index2"
                :index="item2.path"
              >
                <span>{{ item2.menuName }}</span>
              </el-menu-item>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :key="index" :index="item.path">
              <template v-if="item.iconClass && item.iconClass.length > 0">
                <i :class="item.iconClass"></i>
                <span slot="title">{{ item.menuName }}</span>
              </template>
              <template v-else>
                <span slot="title">{{ item.menuName }}</span>
              </template>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </section>
  </el-aside>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  props: {
    theme: {
      type: String,
      default: () => {
        return "leftAsideTheme1";
      }
    },
    iconClass: String,
    muneTitle: String,
    menuData: Array
  },
  data() {
    return {
      activeIndex: "", // 动态，根据地址反查
      sHTime: 100,
      patd: false,
      isCollapse: false,
      headShow: true
    };
  },
  computed: {
    ...mapGetters(["privilegeConfig", "leftMenuZoom"])
  },
  watch: {
    $route(to) {
      this.initActiveIndex(to.path);
    },
    isCollapse(n) {
      this.setLeftMenuZoom(n);
      let leftAsideElMainSeWidth = 0;
      if (!n) {
        leftAsideElMainSeWidth =
          document.getElementsByClassName("leftAsideElMainFrom")[0]
            .offsetWidth - 200;
      } else {
        leftAsideElMainSeWidth =
          document.getElementsByClassName("leftAsideElMainFrom")[0]
            .offsetWidth - 64;
      }
      this.setRightMianWidth(leftAsideElMainSeWidth);
    }
  },
  components: {},
  methods: {
    ...mapMutations(["setLeftMenuZoom", "setRightMianWidth"]),
    handleSelect(index) {
      if (index != null && index.toString().length > 0) {
        this.$router.push(index);
      }
    },
    initActiveIndex(path) {
      const pathArray = path.split("/");
      this.activeIndex =
        pathArray.length > 4
          ? "/" +
            pathArray[1] +
            "/" +
            pathArray[2] +
            "/" +
            pathArray[3] +
            "/" +
            pathArray[4]
          : "/" + pathArray[1] + "/" + pathArray[2] + "/" + pathArray[3];
    },
    handleClose() {
      if (this.isCollapse == true) {
        this.isCollapse = false;
      } else {
        this.isCollapse = true;
      }
    }
  },
  created() {
    this.initActiveIndex(this.$route.path);
    this.setLeftMenuZoom(false);
  },
  // eslint-disable-next-line no-dupe-keys
  mounted() {
    // 添加主题
    document.getElementById("lyoutFromLeftSide").classList.add(this.theme);
    // 计算右侧宽度
    let leftAsideElMainSeWidth =
      document.getElementsByClassName("leftAsideElMainFrom")[0].offsetWidth -
      200;
    this.setRightMianWidth(leftAsideElMainSeWidth);
  }
};
</script>

<style scoped lang="less">
@import "./leftAsideThemeScoped.less";
</style>

<style lang="less">
@import "./leftAsideTheme.less";
</style>
